export const INQUIRY_ID_KEY = 'registrationInquiryId';
export const INQUIRY_TOKEN_KEY = 'registrationInquiryToken';
export const GUEST_NAME_KEY = 'registrationInquiryName';
export const PENDING_REGISTRATION_ID_KEY = 'pendingRegistrationId';
export const PENDING_REGISTRATION_TOKEN_KEY = 'pendingRegistrationToken';

/**
 * Anonymous chat lives in sessionStorage, not localStorage: on a shared or public
 * computer, closing the browser must end the conversation rather than leave the next
 * person holding a token that reopens someone else's thread. Signed-in vendors keep a
 * persistent history because their thread is tied to their account, not to the browser.
 */
export const guestChatStorage: Storage = sessionStorage;

/**
 * Keys that belong to the browser rather than the signed-in session. Their
 * secrets are issued once and only ever stored hashed on the server, so
 * clearing them on logout strands the vendor: the pending-registration edit
 * window becomes unreachable forever.
 */
const BROWSER_SCOPED_KEYS = [PENDING_REGISTRATION_ID_KEY, PENDING_REGISTRATION_TOKEN_KEY];

export function clearSessionKeepingBrowserContext(): void {
  const preserved = BROWSER_SCOPED_KEYS.map(
    (key) => [key, localStorage.getItem(key)] as const,
  ).filter(([, value]) => value !== null);

  localStorage.clear();

  preserved.forEach(([key, value]) => localStorage.setItem(key, value as string));
}
